// import * as React from "react";
// import Input from "../../Input-new/Input";
// import SelectLender from "../../SelectLender/SelectLender";
// import SelectAgentAll from "../../SelectAgentAll/SelectAgentAll";
// import Dropdown from "../../Dropdown/Dropdown";
// import Checkbox from "../../CheckboxNew/Checkbox";
// import Textarea from "../../Textarea-new/Textarea";
// import { splitTimestamp } from "../../../date-converter";
// import UploadFiles from "./UploadFiles";
// import { maxHscMembers } from "../../../consts/consts";
// import moment from "moment";
// import { addCommasToNumber } from "../../../utils";

// const hscAgreementFile=[{
//     label:'HSC Agreement',
//     name:'HSC_AGREEMENT_FILE'
// }]

// const loanCommitmentFile=[{
//     label:'Loan Commitment',
//     name:'LOAN_COMMITMENT_FILE'
// }]
// export function priceToNumber(str) {
//     if (typeof str === "string") {
//         str = str.trim().replace(/\$|,/g, "");
//         const num = Number(str);
//         if (str && num === num) {
//             // !isNaN
//             return num;
//         }
//     }
//     return false;
// }

// const closingStatementFile=[{
//     label:'Closing Statement',
//     name:'CLOSING_STATEMENT_FILE'
// }]

// const Loan = ({isAgent, isTeamMember, data, displayedAgentsNr, handleChangeInput, handleChangeDropdown, handleInputBlur, addHscMember, handleChangeFile, openHscPayments, hscTeamMembers, addNewItem, newLender, newAgent, viewMode, deleted}) => {
//     const isUncheckable = viewMode || (!viewMode && !isTeamMember) || data.HSC_STATUS !== "Closed";
//     const {timestampDate, timestampHour} = splitTimestamp(data.HSC_APPROVED_TIMESTAMP);
//     const hscTotalFee = data.HSC_TOTAL_FEE ? priceToNumber(data.HSC_TOTAL_FEE) : 0;
//     const referral = data.REFERRAL ? priceToNumber(data.REFERRAL) : 0;
//     const credits = data.CREDITS_AT_CLOSING ? priceToNumber(data.CREDITS_AT_CLOSING) : 0;
//     const bankBonus = data.BANK_BONUS ? priceToNumber(data.BANK_BONUS) : 0;
//     const hscInvoiceImageURL = 'https://s3-us-west-1.amazonaws.com/arcfusion-env-01-open/arcfusion/skydata/arc11a015/media/apps/arcimedes/v0/10ae4ac42c8b55fedab686b92b8abb6aa22af74a8076eedff868c9068c003b272fc39588a86c200563a25952663d5ce4670090de0ae298c5f2d0d966a0c1129b_HSC-Invoice_Wire_Instructions.jpg?w=120&h=100';
//     const todaysDate = moment(new Date()).format('MM/DD/YY');

//     function printHscInvoice(event){
//         event.preventDefault();
//         print();
//     }

//     return (
//         <React.Fragment>
//         <div className="print-HSC-Invoice">
//         <img src={hscInvoiceImageURL} height={0}/>
//             <div className="hsc-content HSC-date">{todaysDate}</div>
//             <div className="hsc-content HSC-Property-Address">
//                 {data.NAME}<br/>
//                 {data.ADDRESS}<br/>
//                 {data.CITY}, {data.STATE} {data.ZIP}
//             </div>
//             <div className="hsc-content HSC-Loan-Amount">
//                 {data.LOAN_AMOUNT && `$${data.LOAN_AMOUNT}`}
//             </div>
//             <div className="hsc-content HSC-Fee-Percentage">
//                 {data.HSC_FEE_PERCENTAGE && `${Number(data.HSC_FEE_PERCENTAGE).toFixed(2)}%`}
//             </div>
//             <div className="hsc-content HSC-Total-Fee">
//             {data.HSC_TOTAL_FEE && `$${addCommasToNumber(Number(data.HSC_TOTAL_FEE.replace(/,/g, "")).toFixed(2))}`}
//             </div>
//         </div>
//         <div className={data.OTHER_FINANCING ? 'Loan other-financing' : 'Loan'}>
//             <div className="Loan_column">
//                 <SelectLender
//                     className="Loan_column_item"
//                     isFromProperty
//                     value={data.LENDER_ID}
//                     valueKey="LENDER_ID"
//                     label="Lender"
//                     data={data}
//                     handleParentChange={handleChangeDropdown}
//                     withAddNew
//                     addNewItem={addNewItem}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     newLender={newLender}
//                     withContact />
//                 <Dropdown
//                     className="Loan_column_item"
//                     data={data}
//                     isFromProperty
//                     optionsType="loan"
//                     value={data.LOAN_TYPE}
//                     valueKey="LOAN_TYPE"
//                     label="Loan Type"
//                     disabled={isAgent}
//                     handleParentChange={handleChangeDropdown}
//                     viewMode={viewMode}
//                     deleted={deleted} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="integer"
//                     name="LOAN_AMOUNT"
//                     label="Loan Amount"
//                     value={data.LOAN_AMOUNT}
//                     disabled={isAgent}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     isDollar />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="percent"
//                     name="LTV"
//                     label="LTV"
//                     value={data.LTV}
//                     disabled
//                     tooltip='Loan Amount / Price'
//                     tooltipPosition='down'
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     decimals={2} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="percent"
//                     name="INTEREST_RATE"
//                     label="Interest Rate"
//                     value={data.INTEREST_RATE}
//                     disabled={isAgent}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     decimals={3} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="number"
//                     name="AMORTIZATION"
//                     label="Amortization"
//                     value={data.AMORTIZATION}
//                     disabled={isAgent}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted} />
//                 <Textarea
//                     className="Loan_column_item"
//                     theme='white'
//                     name='NOTES'
//                     label='Notes'
//                     value={data.NOTES}
//                     maxWidth='100%'
//                     viewMode={viewMode}
//                     handleParentChange={handleChangeInput} />
//             </div>
//             <div className="Loan_column">
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="number"
//                     name="TERM"
//                     label="Term"
//                     value={data.TERM}
//                     disabled={isAgent}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="date"
//                     name="MATURITY_DATE"
//                     label="Maturity Date"
//                     value={data.MATURITY_DATE}
//                     disabled
//                     tooltip={`'Term' years from Close of Escrow`}
//                     tooltipPosition='down'
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="integer"
//                     name="ANNUAL_LOAN_PAYMENT"
//                     label="Annual Loan Payment"
//                     value={data.ANNUAL_LOAN_PAYMENT}
//                     disabled
//                     tooltip='-PMT(Interest Rate / 12, Amortization * 11.8, Loan Amount) * 12)'
//                     tooltipPosition='down'
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     isDollar />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="integer"
//                     name="CASH_FLOW"
//                     label="Cash Flow"
//                     value={data.CASH_FLOW}
//                     disabled
//                     tooltip='NOI - Loan Payment'
//                     tooltipPosition='down'
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     isDollar />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="percent"
//                     name="CASH_ON_CASH"
//                     label="Cash on Cash"
//                     value={data.CASH_ON_CASH}
//                     disabled
//                     tooltip='Cash Flow / Down Payment'
//                     tooltipPosition='down'
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     decimals={2} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="percent"
//                     name="DSCR"
//                     label="DSCR"
//                     value={data.DSCR}
//                     disabled
//                     tooltip='NOI / Loan Payment'
//                     tooltipPosition='down'
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     decimals={2} />
//                 <Input
//                     className="Loan_column_item"
//                     type="text"
//                     valueType="text"
//                     name="PREPAYMENT_PENALTY"
//                     label="Prepayment Penalty"
//                     value={data.PREPAYMENT_PENALTY}
//                     handleParentChange={handleChangeInput}
//                     viewMode={viewMode}
//                     deleted={deleted} />
//             </div>
//             {!data.OTHER_FINANCING &&
//                 <div className="Loan">
//                     <div className="Loan_column">
//                         <Input
//                             className="Loan_column_item"
//                             placeholder="MM/DD/YYYY"
//                             type="text"
//                             valueType="date"
//                             name="HSC_LISTED_DATE"
//                             label="Date Listed"
//                             value={data.HSC_LISTED_DATE}
//                             disabled={isAgent}
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             deleted={deleted} />
//                         <Input
//                             className="Loan_column_item"
//                             type="text"
//                             valueType="number"
//                             name="HSC_EXPIRATION_NO_OF_MONTHS"
//                             label="# Of Months"
//                             value={data.HSC_EXPIRATION_NO_OF_MONTHS}
//                             disabled={isAgent}
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             deleted={deleted} />
//                         <Input
//                             className="Loan_column_item"
//                             placeholder="MM/DD/YYYY"
//                             type="text"
//                             valueType="date"
//                             name="HSC_EXPIRATION_DATE"
//                             label="Listing Expiration Date"
//                             value={data.HSC_EXPIRATION_DATE}
//                             disabled={isAgent}
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             deleted={deleted} />
//                         <UploadFiles
//                             classNames="Loan_column_item"
//                             data={data}
//                             viewMode={viewMode}
//                             deleted={deleted}
//                             handleChangeFile={handleChangeFile}
//                             maxFilesAmount={hscAgreementFile.length}
//                             items={hscAgreementFile}
//                             disabled={isAgent} />
//                         <Input
//                             className="Loan_column_item"
//                             type="text"
//                             valueType="percent"
//                             name="HSC_FEE_PERCENTAGE"
//                             label="HSC Fee Percentage"
//                             value={data.HSC_FEE_PERCENTAGE}
//                             disabled={isAgent}
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             deleted={deleted}
//                             isDollar />

//                         {hscTeamMembers.map((elem, index) => {
//                             if (index < displayedAgentsNr)
//                                 return (
//                                     <Dropdown
//                                         key={'hsc-team-' + index}
//                                         className="Loan_column_item hsc_dropdown"
//                                         data={data}
//                                         optionsType='team-members'
//                                         optionLabelKey='NAME'
//                                         value={elem}
//                                         valueKey={`HSC_TEAM_MEMBER_${index + 1}`}
//                                         percentKey={`HSC_TEAM_MEMBER_${index + 1}_PERCENT`}
//                                         label={`HSC Team Member ${index + 1}`}
//                                         viewMode={viewMode}
//                                         handleParentChange={handleChangeDropdown}
//                                         handleInputParentChange={handleChangeInput}
//                                         deleted={deleted}
//                                         optionKey={"EMAIL"}
//                                         hasAgentPercent />);
//                         })}
//                         {!viewMode && displayedAgentsNr < maxHscMembers &&
//                             <div className='Loan_column_item'>
//                                 <button className="button-new positive" onClick={addHscMember}>Add Member</button>
//                             </div>}
//                         <Input
//                             className="Loan_column_item"
//                             placeholder="MM/DD/YYYY"
//                             type="text"
//                             valueType="date"
//                             name="LOAN_CLOSING_DATE"
//                             label="Loan Closing Date"
//                             value={data.LOAN_CLOSING_DATE}
//                             disabled={isAgent}
//                             handleParentChange={handleChangeInput}
//                             handleParentBlur={handleInputBlur}
//                             viewMode={viewMode}
//                             deleted={deleted} />
//                         <UploadFiles
//                             classNames="Loan_column_item"
//                             data={data}
//                             viewMode={viewMode}
//                             deleted={deleted}
//                             handleChangeFile={handleChangeFile}
//                             maxFilesAmount={loanCommitmentFile.length}
//                             items={loanCommitmentFile}
//                             disabled={isAgent} />
//                     </div>
//                     <div className="Loan_column">
//                         <Input
//                             className="Loan_column_item"
//                             disabled
//                             tooltip='Loan Amount * HSC Fee Percentage'
//                             tooltipPosition='down'
//                             type="text"
//                             valueType="float"
//                             name="HSC_TOTAL_FEE"
//                             label="Total Fee - Auto"
//                             value={data.HSC_TOTAL_FEE}
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             deleted={deleted}
//                             decimals={2}
//                             isDollar />
//                         <div className='referral-container'>
//                             <Input
//                                 className="Loan_column_item"
//                                 type="text"
//                                 valueType="float"
//                                 name="REFERRAL"
//                                 label="Referral"
//                                 value={data.REFERRAL}
//                                 handleParentChange={handleChangeInput}
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 decimals={2}
//                                 isDollar />
//                             <Input
//                                 className="referral-percent"
//                                 type="text"
//                                 valueType="percent"
//                                 name="REFERRAL_PERCENT"
//                                 value={data.REFERRAL_PERCENT}
//                                 disabled={isAgent}
//                                 handleParentChange={handleChangeInput}
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 decimals={2} />
//                         </div>
//                         <SelectAgentAll
//                             className="Loan_column_item"
//                             isFromProperty
//                             value={data.REFERRED_BY_ID}
//                             valueKey="REFERRED_BY_ID"
//                             typeKey="REFERRED_BY_TYPE"
//                             label="Referred By"
//                             data={data}
//                             handleParentChange={handleChangeDropdown}
//                             withAddNew
//                             addNewItem={addNewItem}
//                             newAgent={newAgent}
//                             viewMode={viewMode}
//                             deleted={deleted} />
//                         <Input
//                             className="Loan_column_item"
//                             type="text"
//                             valueType="float"
//                             name="CREDITS_AT_CLOSING"
//                             label="Credits @ Closing"
//                             value={data.CREDITS_AT_CLOSING}
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             deleted={deleted}
//                             decimals={2}
//                             isDollar />
//                         <div className='referral-container'>
//                             <Input
//                                 className="Loan_column_item"
//                                 type="text"
//                                 valueType="float"
//                                 name="BANK_BONUS"
//                                 label="Bank Bonus"
//                                 value={data.BANK_BONUS}
//                                 handleParentChange={handleChangeInput}
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 decimals={2}
//                                 isDollar />
//                             <Input
//                                 className="referral-percent"
//                                 type="text"
//                                 valueType="percent"
//                                 name="BANK_BONUS_PERCENT"
//                                 value={data.BANK_BONUS_PERCENT}
//                                 disabled={isAgent}
//                                 handleParentChange={handleChangeInput}
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 decimals={2} />
//                         </div>
//                         <Input
//                             className="Loan_column_item"
//                             type="text"
//                             valueType="float"
//                             name="HSC_LIST_FEE"
//                             label="HSC Fee - auto"
//                             tooltip='Total Fee - Referral - Credits + Bank Bonus'
//                             tooltipPosition='down'
//                             value={hscTotalFee - referral - credits + bankBonus}
//                             disabled
//                             handleParentChange={handleChangeInput}
//                             viewMode={viewMode}
//                             onInputClick={data.HSC_APPROVED ? openHscPayments : null}
//                             deleted={deleted}
//                             decimals={2}
//                             isDollar />
//                         <div className='Loan_column_item'>
//                             <Checkbox
//                                 text='Approved'
//                                 type={isUncheckable ? 'uncheckable' : 'checkable'}
//                                 isSelected={data.HSC_APPROVED}
//                                 handleClick={handleChangeInput}
//                                 name='HSC_APPROVED' />
//                             <div className="Loan_column_timestamp-container">
//                                 <span className="Loan_timestamp">{data.HSC_APPROVED_INITIALS || '-'}</span>
//                                 {timestampDate && <span className="Loan_timestamp">{timestampDate}</span>}
//                                 {timestampHour && <span className="Loan_timestamp">{timestampHour}</span>}
//                             </div>
//                         </div>
//                         <UploadFiles
//                             classNames="Loan_column_item"
//                             data={data}
//                             viewMode={viewMode}
//                             deleted={deleted}
//                             handleChangeFile={handleChangeFile}
//                             maxFilesAmount={closingStatementFile.length}
//                             items={closingStatementFile}
//                             disabled={isAgent} />
//                             <div>
//                             <button className="button-new text" onClick={printHscInvoice}>Invoice</button>
//                             </div>
//                     </div>
//                 </div>}
//         </div>
//         </React.Fragment>
//     );
// };

// export default Loan;



import * as React from "react";
import Input from "../../Input-new/Input";
import SelectLender from "../../SelectLender/SelectLender";
import SelectAgentAll from "../../SelectAgentAll/SelectAgentAll";
import Dropdown from "../../Dropdown/Dropdown";
import Checkbox from "../../CheckboxNew/Checkbox";
import Textarea from "../../Textarea-new/Textarea";
import { splitTimestamp } from "../../../date-converter";
import UploadFiles from "./UploadFiles";
import { maxHscMembers } from "../../../consts/consts";
import moment from "moment";
import { addCommasToNumber } from "../../../utils";

const hscAgreementFile=[{
    label:'AthCap Agreement',
    name:'hsc_agreement_file'
}]

const loanCommitmentFile=[{
    label:'Loan Commitment',
    name:'loan_commitment_file'
}]
export function priceToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

const closingStatementFile=[{
    label:'Closing Statement',
    name:'closing_statement_file'
}]

const Loan = ({isAgent, isTeamMember, data, displayedAgentsNr, handleChangeInput, handleChangeDropdown, handleInputBlur, addHscMember, handleChangeFile, openHscPayments, hscTeamMembers, addNewItem, newLender, newAgent, viewMode, deleted}) => {
    const isUncheckable = viewMode || (!viewMode && !isTeamMember) || data.hsc_status !== "Closed";
    const {timestampDate, timestampHour} = splitTimestamp(data.hsc_approved_timestamp);
    const hscTotalFee = data.hsc_total_fee ? priceToNumber(data.hsc_total_fee) : 0;
    const referral = data.referral ? priceToNumber(data.referral) : 0;
    const credits = data.credits_at_closing ? priceToNumber(data.credits_at_closing) : 0;
    const bankBonus = data.bank_bonus ? priceToNumber(data.bank_bonus) : 0;
   // const hscInvoiceImageURL = 'https://strivenext.s3.us-east-1.amazonaws.com/backup/AthCap+Invoice+JP+edits_02.jpg';
    const hscInvoiceImageURL = 'https://strivenext.s3.us-east-1.amazonaws.com/backup/AthCapInvoiceJPedits.jpg';
    const todaysDate = moment(new Date()).format('MM/DD/YY');

 function printHscInvoice(event) {
  event.preventDefault();

  // Save the current title so we can restore it later
  const originalTitle = document.title;

  // Set the title BEFORE print dialog opens
  document.title = "AthCap Invoice - Wire Instructions";

  // Use a small delay to ensure the title change is registered
  setTimeout(() => {
    window.print();

    // Restore original title after a delay
    setTimeout(() => {
      document.title = originalTitle;
    }, 1000);
  }, 100);
}


    return (
        <React.Fragment>
        <div className="print-HSC-Invoice">
        <img src={hscInvoiceImageURL} height={0}/>
            <div className="hsc-content HSC-date">{todaysDate}</div>
            <div className="hsc-content HSC-Property-Address">
                {data.name}<br/>
                {data.address}<br/>
                {data.city}, {data.state} {data.zip}
            </div>
            <div className="hsc-content HSC-Loan-Amount">
                {data.loan_amount && `$${data.loan_amount}`}
            </div>
            <div className="hsc-content HSC-Fee-Percentage">
                {data.hsc_fee_percentage && `${Number(data.hsc_fee_percentage).toFixed(2)}%`}
            </div>
            <div className="hsc-content HSC-Total-Fee">
            {data.hsc_total_fee && `$${addCommasToNumber(Number(data.hsc_total_fee.replace(/,/g, "")).toFixed(2))}`}
            </div>
              {/* <div className="hsc-footer">
    17742 Preston Rd Dallas, TX 75252 &nbsp; | &nbsp;
    MKeeler@athenacapitalre.com &nbsp; | &nbsp;
    (682) 433-2301
  </div> */}
        </div>
        <div className={data.other_financing ? 'Loan other-financing' : 'Loan'}>
            <div className="Loan_column">
                <SelectLender
                    className="Loan_column_item"
                    isFromProperty
                    value={data.lender_id}
                    valueKey="lender_id"
                    label="Lender"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    withAddNew
                    addNewItem={addNewItem}
                    viewMode={viewMode}
                    deleted={deleted}
                    newLender={newLender}
                    withContact />
                <Dropdown
                    className="Loan_column_item"
                    data={data}
                    isFromProperty
                    optionsType="loan"
                    value={data.loan_type}
                    valueKey="loan_type"
                    label="Loan Type"
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="loan_amount"
                    label="Loan Amount"
                    value={data.loan_amount}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="ltv"
                    label="LTV"
                    value={data.ltv}
                    disabled
                    tooltip='Loan Amount / Price'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="interest_rate"
                    label="Interest Rate"
                    value={data.interest_rate}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={3} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="amortization"
                    label="Amortization"
                    value={data.amortization}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Textarea
                    className="Loan_column_item"
                    theme='white'
                    name='notes'
                    label='Notes'
                    value={data.notes}
                    maxWidth='100%'
                    viewMode={viewMode}
                    handleParentChange={handleChangeInput} />
            </div>
            <div className="Loan_column">
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="number"
                    name="term"
                    label="Term"
                    value={data.term}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="date"
                    name="maturity_date"
                    label="Maturity Date"
                    value={data.maturity_date}
                    disabled
                    tooltip={`'Term' years from Close of Escrow`}
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="annual_loan_payment"
                    label="Annual Loan Payment"
                    value={data.annual_loan_payment}
                    disabled
                    tooltip='-PMT(Interest Rate / 12, Amortization * 11.8, Loan Amount) * 12)'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="integer"
                    name="cash_flow"
                    label="Cash Flow"
                    value={data.cash_flow}
                    disabled
                    tooltip='NOI - Loan Payment'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="cash_on_cash"
                    label="Cash on Cash"
                    value={data.cash_on_cash}
                    disabled
                    tooltip='Cash Flow / Down Payment'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="percent"
                    name="dscr"
                    label="DSCR"
                    value={data.dscr}
                    disabled
                    tooltip='NOI / Loan Payment'
                    tooltipPosition='down'
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2} />
                <Input
                    className="Loan_column_item"
                    type="text"
                    valueType="text"
                    name="prepayment_penalty"
                    label="Prepayment Penalty"
                    value={data.prepayment_penalty}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted} />
            </div>
            {!data.OTHER_FINANCING &&
                <div className="Loan">
                    <div className="Loan_column">
                        <Input
                            className="Loan_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="hsc_listed_date"
                            label="Date Listed"
                            value={data.hsc_listed_date}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="number"
                            name="hsc_expiration_no_of_months"
                            label="# Of Months"
                            value={data.hsc_expiration_no_of_months}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Loan_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="hsc_expiration_date"
                            label="Listing Expiration Date"
                            value={data.hsc_expiration_date}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <UploadFiles
                            classNames="Loan_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={hscAgreementFile.length}
                            items={hscAgreementFile}
                            disabled={isAgent} />
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="percent"
                            name="hsc_fee_percentage"
                            label="AthCap Fee Percentage"
                            value={data.hsc_fee_percentage}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar />

                        {hscTeamMembers.map((elem, index) => {
                            if (index < displayedAgentsNr) {
                                // Get all selected team members except the current one
                                const selectedTeamMembers = hscTeamMembers
                                    .map((member, idx) => idx !== index ? member : null)
                                    .filter(member => member);
                                
                                return (
                                    <Dropdown
                                        key={'hsc-team-' + index}
                                        className="Loan_column_item hsc_dropdown"
                                        data={data}
                                        optionsType='team-members'
                                        optionLabelKey='NAME'
                                        value={elem}
                                        valueKey={`hsc_team_member_${index + 1}`}
                                        percentKey={`hsc_team_member_${index + 1}_percent`}
                                        label={`AthCap Team Member ${index + 1}`}
                                        viewMode={viewMode}
                                        handleParentChange={handleChangeDropdown}
                                        handleInputParentChange={handleChangeInput}
                                        deleted={deleted}
                                        optionKey={"EMAIL"}
                                        hasAgentPercent
                                        selectedTeamMembers={selectedTeamMembers} />);
                            }
                        })}
                        {!viewMode && displayedAgentsNr < maxHscMembers &&
                            <div className='Loan_column_item'>
                                <button className="button-new positive" onClick={addHscMember}>Add Member</button>
                            </div>}
                        <Input
                            className="Loan_column_item"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            valueType="date"
                            name="loan_closing_date"
                            label="Loan Closing Date"
                            value={data.loan_closing_date}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            handleParentBlur={handleInputBlur}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <UploadFiles
                            classNames="Loan_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={loanCommitmentFile.length}
                            items={loanCommitmentFile}
                            disabled={isAgent} />
                    </div>
                    <div className="Loan_column">
                        <Input
                            className="Loan_column_item"
                            disabled
                            tooltip='Loan Amount * AthCap Fee Percentage'
                            tooltipPosition='down'
                            type="text"
                            valueType="float"
                            name="hsc_total_fee"
                            label="Total Fee - Auto"
                            value={data.hsc_total_fee}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar />
                        <div className='referral-container'>
                            <Input
                                className="Loan_column_item"
                                type="text"
                                valueType="float"
                                name="referral"
                                label="Referral"
                                value={data.referral}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar />
                            <Input
                                className="referral-percent"
                                type="text"
                                valueType="percent"
                                name="referral_percent"
                                value={data.referral_percent}
                                disabled={isAgent}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2} />
                        </div>
                        <SelectAgentAll
                            className="Loan_column_item"
                            isFromProperty
                            value={data.referred_by_id}
                            valueKey="referred_by_id"
                            typeKey="referred_by_type"
                            label="Referred By"
                            data={data}
                            handleParentChange={handleChangeDropdown}
                            withAddNew
                            addNewItem={addNewItem}
                            newAgent={newAgent}
                            viewMode={viewMode}
                            deleted={deleted} />
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="float"
                            name="credits_at_closing"
                            label="Credits @ Closing"
                            value={data.credits_at_closing}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            decimals={2}
                            isDollar />
                        <div className='referral-container'>
                            <Input
                                className="Loan_column_item"
                                type="text"
                                valueType="float"
                                name="bank_bonus"
                                label="Bank Bonus"
                                value={data.bank_bonus}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2}
                                isDollar />
                            <Input
                                className="referral-percent"
                                type="text"
                                valueType="percent"
                                name="bank_bonus_percent"
                                value={data.bank_bonus_percent}
                                disabled={isAgent}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                decimals={2} />
                        </div>
                        <Input
                            className="Loan_column_item"
                            type="text"
                            valueType="float"
                            name="hsc_list_fee"
                            label="AthCap Fee - auto"
                            tooltip='Total Fee - Referral - Credits + Bank Bonus'
                            tooltipPosition='down'
                            //value={hscTotalFee - referral - credits + bankBonus}
                            value={(hscTotalFee - referral - credits + bankBonus).toFixed(2)}
                            disabled
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            onInputClick={data.hsc_approved ? openHscPayments : null}
                            deleted={deleted}
                            decimals={2}
                            isDollar />
                        <div className='Loan_column_item'>
                            <Checkbox
                                text='Approved'
                                type={isUncheckable ? 'uncheckable' : 'checkable'}
                                isSelected={data.hsc_approved}
                                handleClick={handleChangeInput}
                                name='hsc_approved' />
                            <div className="Loan_column_timestamp-container">
                                <span className="Loan_timestamp">{data.hsc_approved_initials || '-'}</span>
                                {timestampDate && <span className="Loan_timestamp">{timestampDate}</span>}
                                {timestampHour && <span className="Loan_timestamp">{timestampHour}</span>}
                            </div>
                        </div>
                        <UploadFiles
                            classNames="Loan_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={closingStatementFile.length}
                            items={closingStatementFile}
                            disabled={isAgent} />
                            <div>
                            <button className="button-new text" onClick={printHscInvoice} style={{color:"#538EF2"}}>Invoice</button>
                            </div>
                    </div>
                </div>}
        </div>
        </React.Fragment>
    );
};

export default Loan;
